export default ({
  pageState: { editorBlocks },
  data: { blockIds, visibility }
}) => {
  const modifiedBlocks = { ...editorBlocks };
  for (const blockId of blockIds) {
    const block = editorBlocks[blockId];

    modifiedBlocks[blockId] = {
      ...block,
      data: {
        ...JSON.parse(JSON.stringify(block.data)),
        visibility
      },
      editor: null,
      isEdited: true,
      updatedAt: null
    };
  }

  return { editorBlocks: modifiedBlocks, editorHeaderStatus: 'saving' };
};
